/**
 * Native shell bootstrap (Capacitor iOS/Android).
 *
 * Status-bar layout on iOS stays non-overlaying. Android edge-to-edge insets
 * are owned by Cap SystemBars (`--safe-area-inset-*`) + frontend tokens
 * (`--app-safe-*` in style.css) — do not invent per-screen Android hacks here.
 */
import { isIOS, isNative } from './platform'

export async function initNativeShell() {
  if (!isNative()) return

  try {
    const { purgeLegacyPasswordCredentials } = await import('./biometric')
    await purgeLegacyPasswordCredentials()
  } catch (e) {
    console.warn('[NativeShell] legacy credential purge failed:', e?.message || e)
  }

  if (isIOS()) {
    try {
      // Layout only. Both the colour and the icon style are owned by
      // native/systemBars.js, which follows the header colour. Repainting white
      // here would race with it and win whenever this runs second, leaving a
      // white strip above a dark header until the next theme change.
      const { StatusBar } = await import('@capacitor/status-bar')
      await StatusBar.setOverlaysWebView({ overlay: false })
      await StatusBar.show()
    } catch (e) {
      console.warn('[NativeShell] StatusBar init failed:', e?.message || e)
    }

    try {
      // Hide the iOS form accessory bar (prev/next chevrons + Done) above the
      // soft keyboard. iPhone only; unsupported on iPad / web.
      const { Keyboard } = await import('@capacitor/keyboard')
      await Keyboard.setAccessoryBarVisible({ isVisible: false })
    } catch (e) {
      console.warn('[NativeShell] Keyboard accessory bar hide failed:', e?.message || e)
    }
  }
}
